
import * as DataUtil from "Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil";
import * as CustomConfig from "Flow2/components/CustomCollections/CustomDataConfig/CustomDataConfig";
import CustomTypes from "Flow2/components/CustomCollections/CustomDataConfig/CustomDataTypes";
import { getApiData } from "Flow2/components/CustomCollections/CustomDataApi/CustomDataApi";
import { isPMDB, isTranscoder1, isMaryTv, isFrancetv, isNLW }
    from 'Flow2/components/CustomCollections/CustomDataControllers/CustomAppController';
import getGrantingForApp from "Flow2/components/CustomCollections/CustomDataControllers/CustomGrantingController";
import { getUserInfos } from "Flow2/components/CustomCollections/CustomDataControllers/CustomUserController";

export const checkAndUpdateConfigForApp = ({ uiConfig, tempConfig, flexConfig }) => {
    if (DataUtil.isFrancetv()) {
        let newConfig = [...tempConfig];
        if (uiConfig.tags && uiConfig.tags.length > 0) {
            let tags = uiConfig.tags.map(item => {
                let obj = getCustomWidgets({ item });
                return { name: item.name, inputType: obj.inputType || null, lgMsId: `data.${item.name}` }
            });
            newConfig = newConfig.map(item => ({ ...item, data: tags }))
        }
        return addFieldsToConfigDataForApp(newConfig, flexConfig, "workflows");
    }

    return tempConfig;
}

export const uniqueItemsDataForApp = ({ data, property }) => {
    if (data) {
        if (property) {
            return data.reduce((acc, cur) => {
                let existingItem = acc.find(item => item[property] === cur[property])
                if (!existingItem) acc = [...acc, cur];
                return acc;
            }, []);
        }
        return data;
    }
    return [];
}

export const initObjectsForApp = (ddname, uiName, uiConfig, customDataObjects, lang) => {
    let lg = DataUtil.getLanguage(lang);
    if (isFrancetv() && uiConfig && uiConfig[uiName] && uiConfig[uiName].length >= 2) {
        let standardObj = uiConfig[uiName][0];
        if (standardObj && (standardObj.id !== undefined && standardObj.id !== "") && standardObj.name && ddname && customDataObjects)
            return {
                [`${ddname}Items`]: [{ ID: standardObj.id, [lg]: standardObj.name }],
                [`${ddname}Show`]: "none",
                [`${ddname}_apptmp`]: standardObj.id,
                //[`${ddname}_tmp`]: standardObj.name,
                customDataObjects: { ...customDataObjects, [`${ddname}`]: standardObj.id }
            }
        return false;
    }
    return false;
}

export const addFieldsToConfigDataForApp = (uploadConfig, uiConfig, uiName) => {
    let configField = { ...CustomTypes.CUSTOM_TEMPLATE_FIELD };
    let shouldAdd = false;
    if (isFrancetv() && uiConfig && uiConfig[uiName] && uiConfig[uiName].length >= 2) {
        shouldAdd = true;
        configField.name = "workflow";
        configField.lgMsId = "data.workflow";
        configField.mandatory = true;
    }
    if (shouldAdd) {
        let wfData = uiConfig[uiName].map(item => {
            if ((item.id !== undefined && item.id !== "") && item.name)
                return { ID: (item.id == 0) ? '0' : item.id, DE: item.name, EN: item.name, FR: item.name }
            return null;
        }).filter(item => item ? true : false);

        configField.data = wfData;
        return [{
            data: [configField],
            lgMsId: "data.tab.workflowdata",
            name: "workflowdata"
        }, ...uploadConfig]
    }
    return uploadConfig;
}

export const changeConfigToMWFieldsForApp = (objects, uiConfig = null, formDesign = null) => {
    if (formDesign && formDesign === CustomTypes.UPLOAD_FORM) {
        let handleArr = null;
        if (isNLW()) handleArr = [{ configfield: "containertype", mwfield: "_cliptype" }];
        if (handleArr) {
            for (let i in objects) {
                handleArr.map(item => {
                    if (i.includes(item.configfield)) {
                        let changed = item.mwfield;
                        objects[changed] = objects[i];
                        delete objects[i];
                    }
                })
            }
        }
        if (isFrancetv() && uiConfig && uiConfig.uploadWorkflows && uiConfig.uploadWorkflows.length == 1) {
            uiConfig.uploadWorkflows.forEach(item => {
                if (item.id) objects.workflow = item.id;
            })
        }
    }
    return objects
}

export const getGeneralSettingsForApp = (uiConfig) => {
    let uiLangData = CustomConfig.APP_LANG;
    let uilanguage = {
        inputType: 'CustomStandardSelect',
        lgMsId: 'profile.languageLb',
        name: 'uilanguage',
        data: [
            { ID: "deutsch", DE: "Deutsch", EN: "German" },
            { ID: "english", DE: "Englisch", EN: "English" }
        ]
    }
    if (uiConfig && uiConfig.languages) {
        uiLangData = uiLangData.filter(item => {
            if (uiConfig.languages[item.ID]) {
                Object.keys(uiConfig.languages).map(id => {
                    let upperId = id.toUpperCase();
                    if (!item[upperId]) item[upperId] = item.EN;
                })
                return item;
            }
        });
    }
    if (uiLangData.length > 0) uilanguage.data = uiLangData;

    return [uilanguage];
}

export const getDateFormatForApp = (uiConfig) => {
    if (!isPMDB() && uiConfig && uiConfig.dateFormat) {
        let newDateFormat = uiConfig.dateFormat.toLowerCase();
        newDateFormat = newDateFormat.replace("mm", "MM");
        return newDateFormat;
    }
    return CustomTypes.DATE_FORMAT;
}

export const shouldRefreshDataForApp = (name, formDesign) => {
    if (isNLW() && (name == CustomTypes.API_PROGRAMORSERIES || name == CustomTypes.API_PARENTSERIES) && formDesign === CustomTypes.UPLOAD_FORM) {
        return true;
    }
    return false;
}

export const isNewEntryForApp = (obj, formDesign) => {
    if (isNLW() || isFrancetv()) {
        if (obj && obj.length === 0 && formDesign === CustomTypes.UPLOAD_FORM)
            return true;
        return false;
    }
    return false;
}

export const refreshApiContentForApp = (ddname, propsData) => {
    if (!isPMDB() && propsData && propsData.customAppData) {
        if (propsData.customAppData[ddname]) return true;
    }

    return false;
}

export const getApiDataForApp = (propsId, propsName, storeObjects, lg, name) => {
    if (storeObjects && storeObjects[name] && storeObjects[name].length > 0)
        return storeObjects[name].map(item => {
            if (isNLW()) {
                let gui_type = '';
                if (item["type"] === CustomTypes.MW_SERIES_PROGRAM) gui_type = CustomTypes.GUI_SERIES_PROGRAM;
                if (item["type"] === CustomTypes.MW_SERIES_SERIES) gui_type = CustomTypes.GUI_SERIES_SERIES;
                if (item["type"] === CustomTypes.MW_SERIES_SEASON) gui_type = CustomTypes.GUI_SERIES_SEASON;
                if (item["type"]) {
                    let titleAndType = "ID:" + item["id"] + " TITLE: " + item[propsName] + " TYPE: " + gui_type;
                    return ({ ID: item[propsId], DE: titleAndType, EN: titleAndType, RU: titleAndType, FR: titleAndType, CY: titleAndType });
                }

                let idAndTitle = "ID:" + item["id"] + " -- TITLE: " + item[propsName];
                return ({ ID: item[propsId], DE: idAndTitle, EN: idAndTitle, RU: idAndTitle, FR: idAndTitle, CY: idAndTitle });
            }
            return ({ ID: item[propsId], DE: item[propsName], EN: item[propsName], RU: item[propsName], FR: item[propsName] });
        })
            .sort(DataUtil.dynamicSortAndIgnoreCase(lg));

    return [];
}

export const changeFormStyleForApp = (formDesign) => {
    if ((isPMDB() || isTranscoder1() || isMaryTv()) && (formDesign === CustomTypes.UPLOAD_FORM)) {
        return true;
    }
    return false;
}

export const getLeftCountForApp = () => {
    if (isPMDB()) return 1;
    else if (isTranscoder1()) return 3;
    else return 2;
}


export const getFormTabs = (formData) => {
    let tabs = [];
    formData.map(item => {
        if (item.type === "tab") tabs.push({ "name": item.name, "lgMsId": item.name })
    })
    return tabs;
}

const convertMetadataConfig4DropDown = (options, field, user = null) => {
    let data = [];
    let EN = null;
    let RU, FR, CY;
    if (Array.isArray(options) && options.length > 0) {
        options.map(item => {
            let ID = DataUtil.subStringBefore(item, "=");
            let DE = DataUtil.subStringAfter(item, "=");
            EN = DE;
            RU = EN;
            FR = EN;
            CY = EN;
            if (ID && DE) {
                if (getGrantingForApp({ user: user, field: field, grantingField: ID }))
                    data.push({ ID, DE, EN, RU, FR, CY });
            }
        })
    }
    return data;
}

export const convertMetaDataForClipInfo = (data) => {
    let customClipInfo = [];
    try {
        Object.keys(data).map(item => {
            if (data[item].field && ((CustomTypes.APP_CLIPID_FIELDS.indexOf(data[item].field) !== -1)
                || (CustomTypes.APP_CREATED_FIELDS.indexOf(data[item].field) !== -1)
                || (CustomTypes.APP_PROD_DATE_FIELDS.indexOf(data[item].field) !== -1))) {

                customClipInfo.push(data[item].field)
            }
        })
    } catch (e) {
        console.log("LAMTEST getClipInfoForApp");
    }
    return customClipInfo;
}


const isCondition = (item, formName, submenu) => {
    if (isNLW()) if (item.tab === submenu && !item[formName] && item.params.condition) return true;
    if (item.tab === submenu && !item[formName] && item.params && item.params.mandatory_upload && item.params.condition) return true;

    return false;
}

const getCondition = (item, formName, submenu) => {
    let condition = { name: "customdisplay", value: "customdisplay", ext: { name: "customdisplay", value: "customdisplay" } };
    if (item.tab === submenu && !item[formName] && item.params && (item.params.mandatory_upload || isNLW()) && item.params.condition) {
        for (let i in item.params.condition) {
            condition.name = i;
            condition.value = item.params.condition[i];
            condition.required = item.params.mandatory_upload ? item.params.mandatory_upload : false;
            if (item.params.conditionext) {
                for (let j in item.params.conditionext) {
                    condition.ext = { name: j, value: item.params.conditionext[j] }
                }
            }
        }
    }
    return condition;
}

const changeInputType = (item, formName, name) => {
    let widget = { inputType: "CustomDataInput", data: null };

    if (isNLW() && formName === CustomTypes.APP_FORM_UPLOAD && (name === CustomTypes.API_SERIES_PARENT || name === CustomTypes.API_PROGRAMORSERIES || name === CustomTypes.API_PARENTSERIES)) {
        widget.inputType = "CustomDropDown";
        widget.data = [];
    }
    if (isNLW() && formName === CustomTypes.APP_FORM_SEARCH && name === "production_date") {
        widget.inputType = "CustomDateGroup";
    }
    if (item.params.datefield && formName === CustomTypes.APP_FORM_SEARCH)
        widget.inputType = "CustomDateGroup";
    if (item.params.datefield && formName === CustomTypes.APP_FORM_UPLOAD)
        widget.inputType = "CustomDateBox";
    if (name.includes("description"))
        widget.inputType = "CustomResizableTextArea";


    return widget;
}

const changeCheckBoxType = ({ item, formName, name, user }) => {
    let widget = { inputType: "CustomCheckBox", data: null };
    if (((formName === CustomTypes.APP_FORM_UPLOAD || formName === CustomTypes.APP_FORM_SEARCH) && (isFrancetv() || isNLW()))) {
        widget.inputType = "CustomDropdownWithFadeBox";
        widget.data = convertMetadataConfig4DropDown(item.options, name, user);

    }
    return widget;
}

const isMandatory = (item, formName, submenu) => {
    if (item.tab === submenu && item[formName] === true && item.params && item.params.mandatory_upload && formName === CustomTypes.APP_FORM_UPLOAD)
        return true;

    return false;
}

export const getCustomWidgets = ({ item, formName, name, submenu, user }) => {
    let widget;
    switch (item.type) {
        case 'text':
            widget = changeInputType(item, formName, name);
            return widget;
        case 'tagtree':
            widget = { inputType: "CustomDropdownWithFadeBox", data: [] }
            return widget;
        case 'textfield':
            widget = { inputType: "CustomResizableTextArea" };
            return widget;
        case 'dropdown':
            widget = { inputType: "CustomDropDown", data: convertMetadataConfig4DropDown(item.options, name, user) };
            return widget;
        case 'checkbox':
            widget = changeCheckBoxType({ item, formName, name, submenu, user });
            return widget;
        case 'datetime':
            widget = { inputType: "CustomDateTimeGroup" }
        default:
            return widget;
    }
}

export const findSubMenuData4Form = (formName, formData, submenu, user = null) => {
    let submenuData = [];
    formData.map(item => {
        if ((item.tab === submenu && item[formName] === true) || isCondition(item, formName, submenu)) {
            let inputType, widget;
            let convertedObj = null;
            let name = item.field;
            let data = null;
            let api = false;
            let mandatory = isMandatory(item, formName, submenu);
            let condition = getCondition(item, formName, submenu);

            widget = getCustomWidgets({ item, formName, name, submenu, user });
            if (widget) {
                inputType = widget.inputType ? widget.inputType : null;
                data = widget.data ? widget.data : null;
            }
            if (data || api) convertedObj = { inputType, lgMsId: item.intl, name, data, api, mandatory, condition: condition };
            else convertedObj = { inputType, lgMsId: item.intl, name, mandatory, condition: condition };
            if (convertedObj)
                submenuData.push(convertedObj);
        }
    })
    return submenuData;
}

export const addSubmenu4Form = (submenu) => {
    switch (submenu.lgMsId) {
        case 'metadata.tab.history':
            return { "name": "videoDetails", "lgMsId": "data.tab.videoDetails", "data": submenu.data };
        default:
            return submenu;
    }
}

export const makeSubDialog = (item, formConfig, formName, tabName, subMenuData) => {
    if (formConfig && formConfig.length > 0) {
        if (formName === CustomTypes.APP_FORM_UPLOAD && item.name === tabName) {
            subMenuData.push({ inputType: "CustomMessageBox", lgMsId: "customdata.selectContentMsg" });
            let subItemSection = [{ inputType: "CustomSubFormSection", name: "appSubForm", data: subMenuData }];
            let subItem = { inputType: "CustomSubForm", lgMsId: tabName, data: subItemSection };
            return formConfig.map(tab => {
                if (tab.name === "masterdata") {
                    let newItem = { ...tab }
                    newItem.data.push(subItem);
                    return newItem;
                }
                return tab;
            });
        }
    }
    return formConfig;
}

export const fetchApiDataForApp = (name, props, lg) => {
    let data;
    if (isTranscoder1() || isMaryTv() || isNLW()) {
        switch (name) {
            case CustomTypes.API_PROJECT:
                data = DataUtil.setInitialObjState("id", "name", props.projects, lg);
                break;
            case CustomTypes.API_ROOM:
                data = DataUtil.setInitialObjState("id", "title", props.rooms, lg);
                break;
            case CustomTypes.API_PARENTSERIES:
            case CustomTypes.API_SERIES_PARENT:
            case CustomTypes.API_PROGRAMORSERIES:
                if (isNLW())
                    //data = getApiDataForApp("id", "title", props.customAppData, lg, name);
                    data = getApiDataForApp("id", "seriestitle", props.customAppData, lg, name);
                break;
        }
    }
    return data;
}

export const setupApiDataForDropDown = (name, data, props) => {
    let lg = DataUtil.getLanguage(props.lg);
    if (isPMDB()) {
        switch (name) {
            case CustomTypes.API_MODELS:
            case CustomTypes.API_TAGS:
                data = getApiData(props[`api${name}`], `${name}`).sort(DataUtil.dynamicSortAndIgnoreCase(lg));
                data = uniqueItemsDataForApp({ data, property: "DE" });
                break;
            case CustomTypes.API_YEAR:
                data = DataUtil.getModelYears() || [];
                break;
            case CustomTypes.API_COUNTRIES:
                data = CustomConfig.countriesArr;
                break;
            case CustomTypes.API_PMDBUSER:
                data = getUserInfos(props.uploaders, lg, "id");
                break;
            case CustomTypes.API_CREATEDBY:
                data = getUserInfos(props.uploaders, lg, "id");
                break;
            case CustomTypes.API_PROJECT:
                data = DataUtil.setInitialObjState("id", "name", props.projects, lg);
                break;
            case CustomTypes.API_ROOM:
                data = DataUtil.setInitialObjState("id", "title", props.rooms, lg);
                break;
        }
        return data;
    }

    return fetchApiDataForApp(name, props, lg);
}


export const initFormDataForApp = (formName, formData, formTabs, user = null) => {
    let formConfig = [];
    if (isPMDB() && CustomTypes.FLEX_APP) {
        if (formName === CustomTypes.APP_FORM_SEARCH) {
            formConfig.push(addSubmenu4Form({ "name": "metaData", "lgMsId": "expertsearch.metadatDataLb", "data": CustomConfig.eSearchBasicData }));
            formConfig.push(addSubmenu4Form({ "name": "advancedData", "lgMsId": "expertsearch.advancedDataLb", "data": CustomConfig.advancedMetadata }));
            formConfig.push(addSubmenu4Form({ "name": "videoDetails", "lgMsId": "expertsearch.videoDetailsLb", "data": CustomConfig.eSearchVideoDetails }));
        } else if (formName === CustomTypes.APP_FORM_UPLOAD) {

            let changedUploadBasic = [...CustomConfig.uploadBasicData];
            changedUploadBasic.push({ inputType: "CustomSubForm", lgMsId: "data.vRightsDefinitionResLb", data: CustomConfig.subRightsForm });
            formConfig.push(addSubmenu4Form({ "name": "metaData", "lgMsId": "upload.masterDataLb", "data": changedUploadBasic }));
            formConfig.push(addSubmenu4Form({ "name": "advancedData", "lgMsId": "upload.optionalDataLb", "data": CustomConfig.uploadadvancedMetadata }));
            formConfig.push(addSubmenu4Form({ "name": "videoDetails", "lgMsId": "upload.VideoDetailsLb", "data": CustomConfig.uploadVideoDetails }));
            formConfig.push(addSubmenu4Form({ "name": "productionData", "lgMsId": "upload.ProductionLb", "data": CustomConfig.uploadProduction }));
            formConfig.push(addSubmenu4Form({ "name": "addToData", "lgMsId": "upload.addToLb", "data": CustomConfig.uploadAddTo }));
        }

    } else {
        if (Array.isArray(formTabs) && formTabs.length > 0) {
            formTabs.map(item => {
                let subMenuData = findSubMenuData4Form(formName, formData, item.name, user);
                let searchTab = "metadata.tab.reference";
                if (Array.isArray(subMenuData) && subMenuData.length > 0) {
                    let submenuName = DataUtil.subStringAfter(item.name, "metadata.tab.");
                    if (isNLW() && formName === CustomTypes.APP_FORM_UPLOAD && item.name === searchTab) {
                        formConfig = makeSubDialog(item, formConfig, formName, searchTab, subMenuData);
                    }
                    else
                        formConfig.push(addSubmenu4Form({ name: submenuName, "lgMsId": item.name, "data": subMenuData }));
                }
            })
        }
        if (isTranscoder1() || isMaryTv()) {
            if (formName === CustomTypes.APP_FORM_UPLOAD) {
                formConfig.push(addSubmenu4Form({ "name": "addToData", "lgMsId": "upload.addToLb", "data": CustomConfig.uploadAddTo }));
            }
        }
    }
    return formConfig;
}